import { get } from 'lodash';
import { DISCOVER_DYNAMIC_SUBCATEGORY_PRIORITIZATION } from '../lib/constants';

const sortFavorites = (favorites, tools) =>
  // non-destructively reverse favorites to show most recently favorited
  favorites
    .reduce((ary, ele) => {
      ary.unshift(ele);
      return ary;
    }, [])
    .filter(app => !!get(tools, `[${app}]`))
    .slice(0, 3);

// If a previous category already shows a tool, this ensures another category won't show the same tool
const getDedupedDiscoverTools = (
  { category, categories, sortedFavorites, tools, user },
  recommendations = []
) => {
  const discoverTools = {};

  get(category, 'categories', []).forEach(subcategory => {
    const { type, name } = subcategory;
    let dedupedItems;

    switch (type) {
      case 'static':
        if (name === 'favorites') {
          discoverTools[name] = sortedFavorites;
        } else {
          const categoryObject = categories.find(cat => cat.name === name);
          dedupedItems = get(categoryObject, 'items', [])
            .filter(app => !!get(tools, `[${app}]`))
            .filter(app => !sortedFavorites.includes(app))
            .filter(app =>
              Object.keys(discoverTools).every(
                k => !discoverTools[k].includes(app)
              )
            )
            .slice(0, 3);

          discoverTools[name] = dedupedItems;
        }
        break;
      case 'dynamic':
        const {
            useSegment,
            useRecommendations,
            recommendedTools
          } = DISCOVER_DYNAMIC_SUBCATEGORY_PRIORITIZATION[name],
          items = useSegment
            ? get(user, `eligibility.${name}`, [])
            : recommendedTools,
          toolsFromRecommendationEngine = [];

        if (useRecommendations) {
          recommendations
            .slice(0, 3)
            .forEach(() => toolsFromRecommendationEngine.push('recommended'));
        }

        dedupedItems = recommendedTools
          .filter(app => !!get(tools, `[${app}]`))
          .filter(app => items.includes(app))
          .filter(app => !sortedFavorites.includes(app))
          .filter(app =>
            Object.keys(discoverTools).every(
              k => !discoverTools[k].includes(app)
            )
          );

        discoverTools[name] = toolsFromRecommendationEngine
          .concat(dedupedItems)
          .slice(0, 3);
        break;
      default:
        break;
    }
  });
  return discoverTools;
};

export { sortFavorites, getDedupedDiscoverTools };
